/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'design-element-two': {
    width: 380,
    height: 158,
    viewBox: '0 0 380 158',
    data: '<path pid="0" d="M-20 10.115c37.206-.407 69.485 11.853 96.684 37.439 18.428 17.329 37.81 33.422 61.093 43.982 19.971 9.072 40.63 13.552 62.664 9.269 1.713-.337 4.898 1.881 5.937 3.735 20.757 36.975 51.549 61.705 91.576 74.793 27.002 8.833 54.482 9.956 82.046 2.176v-9.83c-28.771 9.254-57.261 6.994-85.148-3.202-33.627-12.287-59.886-33.969-78.313-64.878-1.179-1.966-2.133-4.058-3.158-6.038 6.512-4.733 13.137-8.707 18.779-13.79 13.094-11.769 19.62-26.654 18.034-44.432-.884-9.9-5.207-18.228-15.213-21.697-10.077-3.482-18.891.057-26.301 7.036-9.684 9.114-12.898 21.163-12.884 33.815.014 10.645 1.726 21.275 2.863 33.83-7.859.056-16.617.87-25.206.014-21.291-2.135-39.985-11.417-56.882-23.901-13.319-9.845-25.866-20.784-38.287-31.751C50.931 12.559 18.89 1.282-17.22.595-18.147.58-19.074.383-20 .27v9.844zm228.483 77.616c-1.207-5.786-2.807-10.94-3.256-16.178-1.221-14.17-1.151-28.268 9.361-39.629 4.463-4.83 10.133-7.878 16.94-5.575 7.256 2.457 9.235 8.679 9.642 15.602 1.123 18.916-12.351 38.35-32.687 45.78z" _fill="#62E2AA"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/design-element-two.js